module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
	'use strict';

	var _ = {
		loadAttachData: function () {
			this.loadSmallThumbs();

			if (!this.paid) {
				this.loadMainContent();
			}
		},

		trackAttach: function () {
			var api = this.rwom1('#trackDataApi');

			api.psend({id: this.contentId})
				.then(_.trackAttachResponse.bind(this))
				.catch(_.trackAttachResponse.bind(this));
		},

		trackAttachResponse: function (res) {
			res = res.params;

			if (res.answer.status !== true) {
				return false;
			}

			if (res.answer.response.alias === 'ready') {
				this.dispatchEvent('attachProcessingSuccess');
					
				$(this.dom1('.attach-item')).removeClass('processing');
				this.processingStatus = false;
				
				_.loadAttachData.call(this);
			} else if (['error', 'missing_source'].indexOf(res.answer.response.alias) === -1) {
				setTimeout(fox.bind(_.trackAttach, this), 10000);
			}
		}
	};
	
	fox.registerWidget('Conversation_AttachItem', {

		configure: function () {
			this.mainData = null;

			this.registerOptions('', {
				autoRender: true,
				template: 'conversation_attach_row',
				handleDom: {
					onAttachClick: {
						event: 'click',
						target: '.attach-preview',
						eventChecker: fox.bind(function () {return !this.paid;}, this),
						callback: 'onAttachClick'
					},
					unlockAttach: {
						event: 'click',
						target: '.unlock-btn',
						callback: 'unlockAttachHandler'
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		init: function () {
			this.messageId = this.getOption('messageId');
			this.contentId = this.getOption('contentId');
			this.price = Number(this.getOption('price'));
			this.paid = (this.getOption('paid') === 0 && this.price > 0) ? true : false; //значение свойства поменялось бэкэндом после имплементации фронтэнда, поэтому решил малой кровью.
			this.type = this.getOption('type');
			this.attachTitle = this.getOption('attachTitle') || 'Untitled';
			this.attachId = this.getOption('attachId');

			this.getApi('smallThumb', {method: 'Client_Upload.get'});

			if (this.type === 1) {
				this.getApi('mainDataApi', {method: 'Client_Upload.getMap'});
			} else if (this.type === 2) {
				this.getApi('mainDataApi', {method: 'Client_Upload.get'});
			}

			if (this.getOption('processing') === true) {
				this.processingStatus = true;

				this.getApi('trackDataApi', {method: 'Client_Upload.track'});
			}
		
			this.callParent('init', arguments);
		},

		running: function () {
			if (this.processingStatus === true) {
				_.trackAttach.call(this);
			} else {
				_.loadAttachData.call(this);
			}

			this.callParent('running', arguments);
		},

		rendering: function () {
			this._onStartRendering();
			this.callParent('rendering', arguments);
			this._onStopRendering();
		},

		_onStartRendering: function () {
			this.setTemplateOptions({
				cid: this.contentId,
				mid: this.messageId,
				paid: this.paid,
				price: this.price,
				type: this.type,
				attachTitle: this.attachTitle
			});

			if (this.processingStatus === true) {
				this.setTemplateOptions('processing', 1);
			}
		},

		_onStopRendering: function () {
			if (this.smallThumb) {
				this.setAttachSmallThumb(this.smallThumb);
			} else if (this.contentError === true) {
				this.showContentError();
			}
		},

		loadSmallThumbs: function () {
			var api = this.rwom1('#smallThumb');
			var _this = this;

			function cb (resp) {
				var res = resp.params;
				var _api = resp.performer;

				if (fox.objectGet(res, 'answer.status') === true && !fox.isEmpty(res.answer.response)) {
					_this.smallThumb = fox.toArray(res.answer.response).pop();

					_this.contentError = false;

					_this.setAttachSmallThumb(_this.smallThumb);
				} else {
					_this.contentError = true;

					_this.showContentError();
				}
			}

			api.psend({
				id: this.contentId,
				alias: !this.paid ? 'w600i' : 'w29i',
				random: Math.random().toString(),
				messageId: this.messageId
			}).then(cb).catch(cb);

			return this;
		},

		loadMainContent: function () {
			var transport = this.rwom1('#mainDataApi');
			var _this = this;

			function cb1 (resp) {
				var res = resp.params;
				var _api = resp.performer;

				if (res.answer.status === true && !fox.isEmpty(res.answer.response)) {
					_this.mainData = fox.toArray(res.answer.response).pop();
				}
			}

			function cb2 (res) {
				res = res.params;

				if (res.answer && res.answer.response) {
					_this.mainData = res.answer.response;
				}
			}

			switch (this.type) {
				case 2:
					transport.psend({
						id: this.contentId,
						alias: 'h1360i',
						messageId: this.messageId
					}).then(cb1).catch(cb1);

					break;
				case 1:
					transport.psend({
						clientUploadId: this.contentId,
						mode: 'format',
						messageId: this.messageId
					}, true).then(cb2).catch(cb2);

					break;
			}

			return this;
		},

		setAttachSmallThumb: function (thumbUrl) {
			var $tNode = $(this.dom1('.attach-preview'));

			$tNode.css('backgroundImage', ['url(', thumbUrl, ')'].join('')).addClass('success');

			this.hideAttachPreload();
		},

		onAttachClick: function (el) {
			this.dispatchEvent('showAttachment', this.getPublicData());
		},

		getPublicData: function () {
			var publicData = {};
			
			if (!this.paid && this.mainData) {
				publicData = {
					id: this.contentId,
					type: this.type,
					messageId: this.messageId,
					attachTitle: this.attachTitle,
					resId: this.getOption('resId'),
					paid: this.getOption('price'),
				};

				publicData[this.type === 1 ? 'videoData' : 'bigThumb'] = this.mainData;
				if (this.type === 1) {
					publicData.posterUrl = this.smallThumb;
				}
			}

			return publicData;
		},

		unlockAttachHandler: function (el) {
			if (this.contentError === true) {
				console.warn('Content not found!');

				return;
			}

			if (this.contentError === undefined) {
				console.warn('Please wait for the content to load');

				return;
			}

			this.unlockAttach({id: this.contentId, messageId: this.messageId});
		},

		unlockAttach: function (params) {
			this.dispatchEvent('unlockThisContent');
		},

		unlockSuccessfully: function (p, performer) {
			var $atn = $(this.dom1('.attach-item'));

			if (p.id === this.attachId) {
				if ($atn.length) {
					$atn.removeClass('locked');
				}

				this.paid = false;
				this.loadSmallThumbs().loadMainContent();
			}
		},

		hideAttachPreload: function () {
			var $ap = $(this.dom1('.preload'));

			if ($ap.length) {
				setTimeout(function () {
					$ap.hide();
				}, 2000);
			}
		},

		showContentError: function () {
			var $ate = $(this.dom1('.attach-error'));

			if ($ate.length) {
				$ate.addClass('content-error');

				this.hideAttachPreload();
			}
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/conversation/attachItem.js
// module id = 842
// module chunks = 4